<template>
  <section class="relative py-28 bg-surface-brand-low">
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <SeoBlock />
    </div>
  </section>
  <OrdersSection />
  <FAQSection />
  <section class="relative py-28">
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <FooterBlock />
    </div>
  </section>
  <Intercom
    data-test="intercom"
    :hide-launcher="false"
    @ready="onIntercomReady"
  />
</template>

<script setup lang="ts">
import { useHead, useRoute } from '#imports'

import Intercom from '@backmarket/nuxt-layer-care-platform/intercom/Intercom.vue'
import type { IntercomApi } from '@backmarket/nuxt-layer-care-platform/intercom/intercom.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import translations from './HelpCenterHome.translations'
import FAQSection from './components/FAQSection/FAQSection.vue'
import FooterBlock from './components/FooterBlock/FooterBlock.vue'
import OrdersSection from './components/OrdersSection/OrdersSection.vue'
import SeoBlock from './components/SeoBlock/SeoBlock.vue'

const i18n = useI18n()
const route = useRoute()

useHead({
  title: i18n(translations.helpCenterPageTitle),
  htmlAttrs: { lang: useI18nLocale() },
})

const onIntercomReady = (intercomApi: IntercomApi) => {
  if (route.query.show_intercom === 'true') {
    intercomApi('show')

    return
  }

  if (route.query.intercom_ticket_id) {
    intercomApi('showConversation', route.query.intercom_ticket_id.toString())
  }
}
</script>
